let intro = document.querySelector('.intro-sequence');

if (intro) {
  window.onload = function() {
    document.body.classList.add('body-no-scroll');
    localStorage.setItem('introShown', 'true');

    setTimeout(() => {
      disableIntro();
    }, 3300);

    // if (localStorage.getItem('introShown') === 'true') {
    //   disableIntro();
  	// }
  };

  const disableIntro = () => {
    document.body.classList.remove('body-no-scroll');
    document.body.classList.add('intro-over');
  }
}
